// extracted by mini-css-extract-plugin
export default {"sweetLoading":"Loader_sweetLoading__vq0e0","Quote":"Loader_Quote__GK+--","QuoteHeader":"Loader_QuoteHeader__r2-5a","blockquote":"Loader_blockquote__3fnxV"};